import { render } from "./CloseModalPropsCmp.vue?vue&type=template&id=30fcab56"
import script from "./CloseModalPropsCmp.vue?vue&type=script&lang=js"
export * from "./CloseModalPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__